/**
 * Display format strings for moment / moment-timezone (`moment(date).format(TIME_FORMAT.DATETIME)`). These are moment
 * tokens — date-fns uses different ones (`yyyy`, `d`, `a`), so don't pass these to date-fns `format`.
 *
 * `_TZ` variants end in `z`, the zone abbreviation (`EST`, `IST`). It only renders on a zoned moment —
 * `moment.tz(date, zone).format(...)` or `moment(date).tz(zone).format(...)`; on a plain `moment()` it prints nothing.
 * Zones with no common abbreviation print their offset instead (`Asia/Dubai` → `+04`).
 */
export const TIME_FORMAT = {
    /** Oct 27, 2026 1:09 AM */
    DATETIME: 'MMM D, YYYY h:mm A',
    /** Oct 27, 26 1:09 AM */
    DATETIME_SHORT: 'MMM D, YY h:mm A',
    /** October 27, 2026 */
    DATE: 'MMMM D, YYYY',
    /** Oct 27, 2026 */
    DATE_MEDIUM: 'MMM D, YYYY',
    /** Oct 27, 26 */
    DATE_SHORT: 'MMM D, YY',
    /** 1:09 AM */
    TIME: 'h:mm A',
    /** October 2026 */
    MONTH_YEAR: 'MMMM YYYY',
    /** Oct 2026 */
    MONTH_YEAR_SHORT: 'MMM YYYY',

    /** Oct 27, 2026 1:09 AM IST */
    DATETIME_TZ: 'MMM D, YYYY h:mm A z',
    /** Oct 27, 26 1:09 AM IST */
    DATETIME_SHORT_TZ: 'MMM D, YY h:mm A z',
    /** 1:09 AM IST */
    TIME_TZ: 'h:mm A z',
    /** Oct 27, 2026 1:09 AM (GMT+05:30) — unambiguous where abbreviations aren't (e.g. CST is US and China) */
    DATETIME_OFFSET: 'MMM D, YYYY h:mm A [(GMT]Z[)]',
} as const

export type TimeFormat = (typeof TIME_FORMAT)[keyof typeof TIME_FORMAT]
